<template>
  <v-expansion-panels multiple v-model="openPanelList" v-if="showPanel">
    <v-expansion-panel
      v-for="(panel, pIndex) in panels"
      :key="pIndex"
      class="mt-2"
      :style="{
        borderRadius: '8px',
        ...panel.panelStyle,
      }"
    >
      <v-expansion-panel-header
        :color="panel.bgColor"
        dark
        style="border-radius: 8px"
      >
        <div style="color: white; font-weight: bold">
          <v-chip :color="panel.color" dark>
            <v-icon class="mr-1">
              {{ panel.icon }}
            </v-icon>
            {{ $t(panel.key) }} ({{ panel.count }})
          </v-chip>
        </div>
      </v-expansion-panel-header>

      <v-expansion-panel-content class="pa-0">
        <v-col cols="12" v-if="panel.items.length > 0">
          <!-- || panel.key == 'waiting' -->
          <div v-if="panel.key == 'success'" class="text-end">
            <v-chip
              v-if="
                !dataMission.use_reward &&
                Array.isArray(panel.total) &&
                panel.total.length > 0 &&
                panel.total[0].point > 0
              "
              color="#FFD740"
            >
              <div class="d-flex align-center">
                <div class="mr-2" style="font-weight: 600">
                  {{ $t("coinTotal") }} :
                </div>
                <div
                  v-if="Array.isArray(panel.total) && panel.total.length > 0"
                  class="d-flex align-center justify-center"
                  style="gap: 4px"
                >
                  <PointSymbol
                    :type="panel.total[0].point_type_type"
                    :symbol="panel.total[0].point_type_symbol"
                    :color="panel.total[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="24"
                  />
                  {{ panel.total[0].point }}
                  {{ panel.total[0].point_type_name }}
                </div>
              </div>
            </v-chip>
            <div
              v-if="dataMission.use_reward"
              class="px-4"
              style="
                width: fit-content;
                background-color: #ffd740;
                border-radius: 16px;
                font-size: 14px;
                margin-right: 0px;
                margin-left: auto;
              "
            >
              <div class="d-flex py-1" style="min-height: 32px">
                <div
                  class="mr-2"
                  style="min-width: fit-content; font-weight: 600"
                >
                  {{ $t("missionReward") }} :
                </div>
                <div
                  v-if="panel.total_reward && panel.total_reward.length > 0"
                  class="d-flex align-center flex-wrap"
                >
                  <div
                    v-for="(item, index) in getTotalReward(panel).list"
                    :key="index"
                    class="text-start mr-1"
                  >
                    {{ item.reward_name }} ({{ item.number_of_unit }}){{
                      index + 1 != getTotalReward(panel).list.length
                        ? ",&nbsp;"
                        : ""
                    }}
                  </div>
                  <div>
                    <div
                      v-if="getTotalReward(panel).more"
                      class="d-flex justify-end"
                      @click="viewTotalRewarMore($event, panel, true)"
                    >
                      <v-chip
                        x-small
                        color="blue"
                        outlined
                        style="
                          border-radius: 6px;
                          cursor: pointer;
                          background-color: #ffffff !important;
                        "
                      >
                        {{
                          $t("textNumberMore", {
                            number: panel.total_reward.length - 1,
                          })
                        }}
                      </v-chip>
                    </div>
                    <div
                      v-else-if="panel.active_view_more"
                      class="d-flex justify-end"
                      @click="viewTotalRewarMore($event, panel, false)"
                    >
                      <v-chip
                        x-small
                        color="orange"
                        outlined
                        style="
                          border-radius: 6px;
                          cursor: pointer;
                          background-color: #ffffff !important;
                        "
                      >
                        {{ $t("textHide") }}
                      </v-chip>
                    </div>
                  </div>
                </div>
                <div v-else>-</div>
              </div>
            </div>
          </div>

          <div v-if="panel.key == 'join' || panel.key == 'waiting'">
            <div
              v-if="dataMission.limit_reached"
              class="d-flex justify-start align-start text-center cover-card-disable"
            >
              <div class="label">{{ $t("limitReached") }}</div>
            </div>
            <div
              v-else-if="dataMission.in_period_remind_date"
              class="d-flex justify-start align-start text-center cover-card-disable"
            >
              <div class="label">
                <v-icon color="red" class="mr-1">mdi-alert</v-icon
                >{{ $t("textComingSoon") }}
              </div>
            </div>
            <div
              v-else-if="!dataMission.in_period_show_time_selected"
              class="d-flex justify-start align-start cover-card-disable"
            >
              <div class="label">
                <v-icon color="red" class="mr-1">mdi-alert</v-icon
                >{{ $t("textTimeCannotJoin") }}
              </div>
            </div>
          </div>
          <v-col
            v-for="(item, index) in panel.items"
            :key="index"
            cols="12"
            class="pt-3 px-0 pb-0"
          >
            <v-card
              :elevation="
                item.id == employee_id || isDisabled(panel.key) ? 0 : 3
              "
              rounded="lg"
              class="pa-2"
              @click="onClickCard(item, pIndex)"
              :style="{
                backgroundColor:
                  item.id == employee_id
                    ? '#F8F8F8'
                    : isDisabled(panel.key)
                    ? '#E0E0E0'
                    : '#FFFFFF',
                opacity: isDisabled(panel.key) ? 0.6 : 1,
                pointerEvents:
                  isDisabled(panel.key) || item.id == employee_id
                    ? 'none'
                    : 'auto',
                cursor:
                  isDisabled(panel.key) || item.id == employee_id
                    ? 'not-allowed'
                    : 'pointer',
              }"
            >
              <div
                style="position: absolute; right: 14px; z-index: 5; top: 14px"
                v-if="item.id == employee_id"
              >
                <v-chip
                  outlined
                  color="info"
                  style="background-color: white !important"
                >
                  <v-icon class="mr-2">mdi-eye</v-icon>
                  {{ $t("viewing") }}</v-chip
                >
              </div>
              <v-card-text
                class="pa-2"
                :style="{ opacity: item.id == employee_id ? '0.8' : '1' }"
              >
                <v-row dense>
                  <v-col cols="12" sm="4" md="2" lg="2">
                    <div
                      style="
                        height: 100px;
                        border-radius: 8px;
                        overflow: hidden;
                      "
                      :style="{
                        height:
                          $vuetify.breakpoint.name !== 'xs' ? '100px' : '200px',
                      }"
                    >
                      <v-img
                        :src="img_url"
                        :style="{
                          height:
                            $vuetify.breakpoint.name !== 'xs'
                              ? '100px'
                              : '200px',
                        }"
                        contain
                      />
                    </div>
                  </v-col>
                  <!-- ข้อมูล -->
                  <v-col cols="12" sm="8" md="8">
                    <div class="d-flex flex-column pl-2">
                      <p
                        class="text-caption mb-0 mt-1"
                        v-if="
                          item.employee && site.account_type != 'individual'
                        "
                      >
                        <v-avatar
                          size="20"
                          class="mr-1"
                          style="background-color: black"
                        >
                          <v-img
                            :src="
                              item.employee.profile_path
                                ? item.employee.profile_path
                                : defaultImage
                            "
                          ></v-img>
                        </v-avatar>
                        <span class="mt-1" style="font-style: italic">
                          {{ item.employee.name }} {{ item.employee.surname }}
                        </span>
                      </p>

                      <p
                        class="description-label title-card text-start mb-0 pb-0 text-subtitle-2"
                      >
                        {{ $t("textLastUpdate") }} :
                        {{ item.updated_at | formatDate }}
                      </p>
                      <p
                        class="mb-0 grey--text text--darken-1"
                        style="font-size: 14px"
                        v-if="item.remark"
                      >
                        {{ $t("note") }} : {{ item.remark ?? "-" }}
                      </p>
                      <p
                        class="mb-0 grey--text text--darken-1"
                        style="font-size: 14px"
                        v-if="item.title_checkin"
                      >
                        {{ $t("textLocationOrBranchName") }} :
                        {{ item.title_checkin ?? "-" }}
                      </p>
                      <div style="font-size: 14px" class="mb-0">
                        <div
                          v-if="dataMission.use_reward == false"
                          class="d-flex align-center"
                        >
                          <span class="mr-2">{{ $t("coinReceived") }} :</span>
                          <div>
                            <div
                              v-if="
                                Array.isArray(item.point) &&
                                item.point.length > 0
                              "
                              class="d-flex align-center justify-center"
                              style="gap: 4px"
                            >
                              <PointSymbol
                                v-if="item.point[0].point"
                                :type="item.point[0].point_type_type"
                                :symbol="item.point[0].point_type_symbol"
                                :color="item.point[0].point_type_color"
                                :is_display="true"
                                :outlined_box="false"
                                :size="24"
                              />
                              <div v-if="item.point[0].point">
                                {{
                                  item.point[0].point.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                }}
                                {{ item.point[0].point_type_name }}
                              </div>
                              <div v-else>-</div>
                            </div>
                          </div>
                        </div>
                        <span v-else>
                          {{ $t("missionReward") }} :
                          <span v-if="item.reward_label">
                            {{ item.reward_label }}
                          </span>
                        </span>
                      </div>

                      <p
                        class="pt-2 mb-0"
                        v-if="!isDisabled(panel.key) && item.id != employee_id"
                        :style="
                          $vuetify.breakpoint.name === 'xs'
                            ? 'text-align:end'
                            : 'position: absolute; bottom: 16px; right: 16px'
                        "
                      >
                        <span>
                          <v-chip small>
                            {{ $t("seeMoreDetail") }}
                            <v-icon small>mdi-chevron-right</v-icon></v-chip
                          >
                        </span>
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-col>
        <div v-else class="text-center py-2">{{ $t("errDataNotFound") }}</div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
  <div v-else>
    <v-col class="d-flex justify-center mt-16">
      <v-img
        class="white--text mx-auto mt-10 empty"
        :src="require('@/assets/images/out-of-stock.png')"
        max-width="150px"
      >
      </v-img>
    </v-col>
    <p class="text-center">{{ $t("errDataNotFound") }}</p>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import PointSymbol from "../../../../components/point/point-symbol.vue";

export default {
  name: "StatusExpansionPanels",
  props: {
    panels: {
      type: Array,
      required: true,
    },
    img_url: {
      type: String,
    },
    employee_id: {
      type: String,
    },
    openPanel: {
      type: Array,
      require: true,
    },
    showPanel: {
      type: Boolean,
    },
    dataMission: {
      type: Object,
      required: true,
    },
  },
  components: { PointSymbol },
  data() {
    return {
      openPanelList: [],
    };
  },
  mounted() {
    this.openPanelList = this.openPanel;
  },
  methods: {
    onClickCard(item, status) {
      this.$router.push({
        name: "my-mission-detail",
        params: {
          status: status,
          id: item.id,
        },
        query: {
          from: status,
        },
      });
      setTimeout(() => {
        window.location.reload();
      }, 100);
    },

    isDisabled(key) {
      if (key === "join" || key == "waiting") {
        return !this.initial_check_allow_play;
      } else {
        return false;
      }
    },
    getTotalReward(param) {
      const list = param.total_reward || [];
      const isMoreThanOne = list.length > 1;
      const activeViewMore = param.active_view_more || false;

      return {
        list: activeViewMore ? list : list.slice(0, 1),
        more: isMoreThanOne && !activeViewMore,
      };
    },
    viewTotalRewarMore(event, param, view) {
      event.stopPropagation();
      this.$set(param, "active_view_more", view);
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
    initial_check_allow_play() {
      return (
        !this.dataMission.limit_reached &&
        this.dataMission.has_permission_play &&
        !this.dataMission.in_period_remind_date &&
        this.dataMission.in_period_show_time_selected
      );
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY, HH:mm");
    },
  },
};
</script>

<style scoped>
.image-wrapper {
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
}
/* ::v-deep.theme--light.v-expansion-panels
  .v-expansion-panel-header
  .v-expansion-panel-header__icon
  .v-icon {
  color: white !important;
} */

.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  /* color: #FFFFFF; */
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
}
</style>
